import { EmptyState, Notice, Seitenzustand, StatusBadge } from "../ui";
import { Card, PageHeader } from "../ui/Layout";
import { useProtokoll, useProtokollPruefung } from "./api";
import { formatDatumZeit } from "@shared/zeit";

export function Protokoll() {
  const protokoll = useProtokoll();
  const pruefung = useProtokollPruefung();
  return (
    <>
      <PageHeader
        title="Änderungsprotokoll"
        sub="Alle Änderungen an Geld, Preisen und Verträgen. Einträge lassen sich weder ändern noch löschen."
        actions={
          pruefung.data ? (
            pruefung.data.ok ? (
              <StatusBadge status="paid">Kette geprüft · {pruefung.data.anzahl} Einträge</StatusBadge>
            ) : (
              <StatusBadge status="error">Kette fehlerhaft ab Nr. {pruefung.data.nr}</StatusBadge>
            )
          ) : null
        }
      />
      <Notice tone="info" title="10 Jahre aufbewahrt, nach GoBD">
        Jeder Eintrag bekommt Zeitstempel, Person und Prüfsumme; jede Prüfsumme hängt von der vorherigen ab.
      </Notice>
      <Seitenzustand query={protokoll} istLeer={(d) => d.eintraege.length === 0} leer={<EmptyState illustration="all-done" title="Noch keine Einträge">Sobald sich etwas ändert, steht es hier.</EmptyState>}>
        {(d) => (
          <Card flush>
            <div className="sc-scroll">
              <table className="rg-table">
                <thead>
                  <tr>
                    <th>Nr.</th>
                    <th>Zeit</th>
                    <th>Wer</th>
                    <th>Bereich</th>
                    <th>Aktion</th>
                    <th>Vorher</th>
                    <th>Nachher</th>
                    <th>Prüfsumme</th>
                  </tr>
                </thead>
                <tbody>
                  {d.eintraege.map((e) => (
                    <tr key={e.nr}>
                      <td className="is-num">{e.nr}</td>
                      <td className="sc-num">{formatDatumZeit(e.zeitpunkt)}</td>
                      <td>{e.akteur}</td>
                      <td>{e.bereich}</td>
                      <td>
                        {e.aktion}
                        {e.objekt ? <div className="sc-muted sc-small">{e.objekt}</div> : null}
                      </td>
                      <td className="app-mono-wrap">{kurz(e.vorher)}</td>
                      <td className="app-mono-wrap">{kurz(e.nachher)}</td>
                      <td className="app-code">{e.hash.slice(0, 4)}…{e.hash.slice(-4)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card>
        )}
      </Seitenzustand>
    </>
  );
}

function kurz(json: string | null): string {
  if (!json) return "–";
  try {
    const v = JSON.parse(json) as unknown;
    if (typeof v !== "object" || v === null) return String(v);
    return Object.entries(v as Record<string, unknown>)
      .map(([k, val]) => `${k}: ${typeof val === "object" ? JSON.stringify(val) : String(val)}`)
      .join("\n");
  } catch {
    return json;
  }
}
